module.exports = __webpack_public_path__ + "static/media/agent-man_.0355b5d5.png";